var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.containerReady
    ? _c(
        "div",
        [
          !_vm.target
            ? _c(
                "div",
                {
                  ref: "popoverTarget",
                  staticClass: "tooltip-target no-outline",
                  attrs: { tabindex: "-1" },
                },
                [
                  _vm._t("popoverTarget", function () {
                    return [
                      _c("icon", {
                        staticClass: "text-danger",
                        attrs: { name: "exclamation-circle" },
                      }),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.componentReady
            ? _c(
                "b-popover",
                {
                  ref: "popover",
                  attrs: {
                    target: _vm.target || _vm.$refs.popoverTarget,
                    container: _vm.container,
                    triggers: _vm.popoverTriggers,
                    placement: _vm.placement,
                    boundary: _vm.boundary,
                    show: _vm.popoverShown,
                    "custom-class": _vm.getCustomClass,
                    title: _vm.title,
                    disabled: _vm.disabled,
                  },
                  on: {
                    "update:show": function ($event) {
                      _vm.popoverShown = $event
                    },
                  },
                },
                [_vm._t("popoverContent")],
                2
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }